module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNEN0RBRDIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0IDEwaDEwdjRIMTR2MTBoLTRWMTRIMHYtNGgxMFYwaDR2MTB6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/add.svg
// module id = pZV3
// module chunks = 1